var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var ColorComponent = /** @class */ (function (_super) {
    __extends(ColorComponent, _super);
    function ColorComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    ColorComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ColorComponent.prototype.ngOnChanges = function (changes) {
        if (changes.val && !this.changeValFlg && this.element) {
            $(this.element).spectrum('set', this.val);
        }
        _super.prototype.ngOnChanges.call(this, changes);
    };
    ColorComponent.prototype.ngAfterViewInit = function () {
        this.element = this.colorElement.nativeElement;
        var options = (this.col.params && this.col.params.options ? this.col.params.options : {});
        var self = this;
        $(this.element).spectrum(Object.assign({}, options, {
            chooseText: this.msg['au.COMPONENT.ColorComponent.label.choose'],
            cancelText: this.msg['au.COMPONENT.ColorComponent.label.cancel'],
            allowEmpty: true,
            showAlpha: false,
            color: self.val,
            disabled: self.col.readonly,
            move: function (color) {
                self.onChangeColor(color);
            },
            hide: function (color) {
                self.onChangeColor(color);
            }
        }));
    };
    ColorComponent.prototype.onChangeColor = function (color) {
        var val = color ? color.toHexString() : null;
        _super.prototype.onChange.call(this, val);
    };
    ColorComponent.prototype.onChange = function (e) {
        $(this.element).spectrum('set', e);
        var color = $(this.element).spectrum('get');
        if (color && e !== color.toHexString()) {
            e = color.toHexString();
            this.val = e;
        }
        _super.prototype.onChange.call(this, e);
    };
    ColorComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        $(this.element).spectrum('destroy');
    };
    ColorComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-color',
                    template: "<ul>\n  <li *ngIf=\"!col.readonly\" class=\"form_li form_li-w100\">\n    <input type=\"text\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" [placeholder]=\"col\" [(ngModel)]=\"val\" (change)=\"onChange(val)\" [key]=\"key\" [col]=\"col\" columnDir>\n  </li>\n  <li *ngIf=\"col.readonly\" class=\"form_li\">\n    <column-formreadonly [componentName]=\"componentName\" [index]=\"index\" [key]=\"key\" [col]=\"col\" [val]=\"val\" [msg]=\"msg\"></column-formreadonly>\n  </li>\n  <li class=\"form_li\">\n    <input #color>\n  </li>\n</ul>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    ColorComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    ColorComponent.propDecorators = {
        colorElement: [{ type: ViewChild, args: ['color',] }]
    };
    return ColorComponent;
}(ColumnBaseComponent));
export { ColorComponent };
//# sourceMappingURL=color.component.js.map